import React from "react";
import { Box } from "@mui/material";
import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import DotLegalSection from "@common/components/dotLegalSection/DotLegalSection";
import { useActivityFormStyles } from "./ActivityForm.styles";

export interface IActivityFormBoxProps {
    title: string;
    startsWithFieldLabel?: boolean;
    children: React.ReactNode;
}

function ActivityFormBox(props: IActivityFormBoxProps) {
    const styles = useActivityFormStyles();

    return (
        <>
            <DotLegalHeader headerStyle={"medium"} marginTop={1} marginBottom={0.5}>
                {props.title}
            </DotLegalHeader>
            <DotLegalSection noPadding>
                <Box sx={[styles.boxContent, !!props.startsWithFieldLabel && styles.boxContentStartingWithFieldLabel]}>{props.children}</Box>
            </DotLegalSection>
        </>
    );
}

export default ActivityFormBox;
